import { useState } from "react";

export default function IndustryExplorer({
  industry,
  index,
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeProduct = industry.products[activeIndex];

  return (
    <details className={`industry-card industry-${industry.accent}`}>
      <summary>
        <span>{String(index + 1).padStart(2, "0")}</span>
        <h3>{industry.name}</h3>
        <p>{industry.detail}</p>
        <span className="industry-open">Explore products</span>
      </summary>

      <div className="industry-detail-panel">
        <figure className="industry-image">
          <img
            key={activeProduct.image}
            src={activeProduct.image}
            alt={activeProduct.label}
            width="960"
            height="720"
            loading="lazy"
          />
          <figcaption aria-live="polite">{activeProduct.label}</figcaption>
        </figure>

        <div className="product-picker">
          <p>Common jobs</p>
          <ul>
            {industry.products.map((product, productIndex) => (
              <li key={product.label}>
                <button
                  type="button"
                  className={productIndex === activeIndex ? "is-active" : ""}
                  aria-pressed={productIndex === activeIndex}
                  onClick={() => setActiveIndex(productIndex)}
                  onPointerEnter={() => setActiveIndex(productIndex)}
                  onFocus={() => setActiveIndex(productIndex)}
                >
                  <span>{String(productIndex + 1).padStart(2, "0")}</span>
                  {product.label}
                </button>
              </li>
            ))}
          </ul>
          <small>Hover, focus or select an item to preview it.</small>
        </div>
      </div>
    </details>
  );
}
